import React from 'react';

import Slots from './components/Slots/Slots';

function App() {
  return (
    <div className="App">
      <Slots />
    </div>
  );
}

export default App;
